<app-breadcrumb [breadcrumb]="'About-us'" [title]="'About-us'"></app-breadcrumb>
<!-- about us section start -->
<section class="about-page  section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h4>CRAFTING YOUR CURIOSITY WITH SHEER LOVE</h4>
                <p class="mb-3">
                    In today's fast-paced world to have the time to choose a special gift for a loved one can be a
                    surmountable task. We know love is all that is needed but we at Giftoholics feel that an appropriate
                    thoughtful gift can add a smile of joy on the receiver's face and make their day even more blissful.
                    We assure you our gifts will create beautiful memories to be cherished for a lifetime. We are one of
                    the best online gift store providing an array of the most unique and personalized gifts. We are sure
                    that shopping for a gift at our e-store will be an experience in itself, as we cater to keeping in
                    mind the various occasions and the different personalities of people. Our product ranges from sleek
                    classy gifts to funky trending ones. Where words fail, gifts speak. So, just take a few minutes away
                    from your busy schedule and surf the website to select the best gift for your loved ones. Hope you
                    have a fun filled experience shopping with us!
                </p>
                <p class="mb-3">
                    Giftoholics was established in 2017 by Aayushi Agrawal, with a vision to provide people a platform
                    to buy personalized and customized gifts to make every occasion memorable for loved ones.
                    We aimed to give a platform to our home-based artists who had the talent but not the knowledge of
                    outsourcing their beautiful handmade products for monetary gains. Thus Giftoholics was a win-win for
                    everyone involved viz the creator, the marketer, and our privileged clients. We at Giftoholics take
                    the utmost care in bringing in new products constantly for our clients globally.
                    We are on a mission to introduce unique and trending gifts accessible to everyone sitting at home.
                    With just a few clicks on our website, you can order an exclusive customized gift to be delivered at
                    your doorsteps.
                </p>
                <p class="mb-3">
                    <b>Vision:</b> <br/>
                    Spreading joy in the lives of people worldwide and making their occasions memorable by giving
                    culturally relevant and exclusive gift suggestions alongside ubiquitous and convenient shopping
                    experience. <br/>
                    <b>Values:</b> <br/>
                    Keeping in mind the best interest of customers. Be passionate about delivering a beautiful
                    experience. Foster a healthy relationship with customers. Respect all individual values and cultures
                    across the globe.
                </p>
                <p class="mb-3">
                    <b>Get in touch:</b> <br/>
                    Customers are our priority. Without you, we wouldn't exist! We try to serve every customer with the
                    utmost care and the best possible way we can. We believe in providing an experience more than just
                    delivering gifts. If you have any questions, concerns, or just want to discuss gift ideas feel free
                    to connect with us over <a class="text-theme-primary" href="mailto:support@giftoholics.com">support@giftoholics.com</a>
                    or you can also Whatsapp us on 8905253279.
                </p>
                <p class="mb-3">
                    Sincere gratitude for choosing and spending some time with us. <br/>
                    -Team Giftoholics.
                </p>
            </div>
        </div>
    </div>
</section>
<!-- about us section end -->
<!-- service section -->
<section class="service border-section small-section mb-4">
    <app-services [sectionItems]="services"></app-services>
</section>
<!-- service section end -->
